import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PenToolPlus = function PenToolPlus(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15 7 8.8345 8.7616c-.305.0871-.4574.1307-.5833.2125a1 1 0 0 0-.2821.2765c-.0844.1242-.131.2758-.2243.5789L4 22m0 0 12.1705-3.7448c.3031-.0932.4546-.1399.5789-.2243a1 1 0 0 0 .2765-.2821c.0818-.1259.1254-.2784.2125-.5833L19 11M4 22l6.586-6.5861M5 8V2M2 5h6m13.8686 2.8686-3.7372-3.7372c-.396-.396-.5941-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0741-.4264.2721-.8224.6682l-.7372.7372c-.396.396-.5941.594-.6682.8224a1 1 0 0 0 0 .618c.0741.2283.2722.4264.6682.8224l3.7372 3.7372c.396.396.5941.5941.8224.6682a1 1 0 0 0 .618 0c.2283-.0741.4264-.2722.8224-.6682l.7372-.7372c.396-.396.5941-.594.6682-.8224a1 1 0 0 0 0-.618c-.0741-.2284-.2722-.4264-.6682-.8224M12 12c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2"
    })
  }));
};
export default PenToolPlus;